import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FormattedDate, FormattedMessage, defineMessages } from 'react-intl';
import Icon from '../../components/Icon';
import Popup from '../../components/Popup';
import Table from '../../components/Table';
import './styles.css';
import ManageUsersActionDropdown from './manage-users-action-dropdown';

const repvisitMessages = defineMessages({
  administrator: {
    id: 'user.update.role.administrator',
    defaultMessage: 'Administrator (All access)',
  },
  publishing: {
    id: 'repvisits.user.update.role.publishing',
    defaultMessage: 'Publishing (Community access + RepVisits + College Profile Management)',
  },
  community: {
    id: 'repvisits.user.update.role.community',
    defaultMessage: 'Community (Community + RepVisits access)',
  },
});

const getStatusIcon = (user, isPrimary) => {
  if (!user.lastLogin) {
    return (
      <Popup
        trigger={<Icon tabIndex={0} data-cy="manage-users-flag-icon" name="flag outline" aria-label="Has not logged in yet" />}
        content="Has not logged in yet"
        on="hover"
      />
    );
  }
  if (isPrimary) {
    return (<Popup trigger={<Icon tabIndex={0} data-cy="manage-users-yellow-star-icon" name="star" color="yellow" aria-label="Primary" />} content="Primary" on="hover" />);
  }
  const lockStatus = JSON.parse(user.lockStatus);
  if (lockStatus.locked) {
    return (<Popup trigger={<Icon tabIndex={0} data-cy="manage-users-locked-icon" name="lock" aria-label="Locked" />} content="Locked" on="hover" />);
  }
  return user.active ?
    (<Popup trigger={<Icon tabIndex={0} data-cy="manage-users-star-empty-icon" name="star outline" aria-label="Active" />} content="Active" on="hover" />) :
    (<Popup trigger={<Icon tabIndex={0} name="ban" aria-label="Inactive" />} content="Inactive" on="hover" />);
};

const RE_INVITE_STATUS = 'FORCE_CHANGE_PASSWORD';

const ManageUsersRow = ({ user, heAccountId, onStatusChange, onReInviteUser, onUnlock, key, isPrimary }) => {
  const lastLogin = user.lastLogin ? <FormattedDate value={new Date(user.lastLogin)} month="short" day="2-digit" year="numeric" /> : '';
  const showReInviteUser = RE_INVITE_STATUS === user.userStatus;
  return (
    <Table.Row key={key}>
      <Table.Cell>
        {getStatusIcon(user, isPrimary)}
      </Table.Cell>
      <Table.Cell>{user.firstName}</Table.Cell>
      <Table.Cell>{user.lastName}</Table.Cell>
      <Table.Cell><div styleName="ellipsis-overflow">{user.email}</div></Table.Cell>
      <Table.Cell>
        <FormattedMessage {...repvisitMessages[user.role]} />
      </Table.Cell>
      <Table.Cell>{lastLogin}</Table.Cell>
      <Table.Cell>
        <ManageUsersActionDropdown
          user={user}
          showReInviteUser={showReInviteUser}
          heAccountId={heAccountId}
          onStatusChange={onStatusChange}
          onUnlock={onUnlock}
          onReInviteUser={onReInviteUser}
        />
      </Table.Cell>
    </Table.Row>
  );
};

ManageUsersRow.propTypes = {
  user: PropTypes.object.isRequired,
  isPrimary: PropTypes.bool,
  key: PropTypes.string,
  heAccountId: PropTypes.string,
  onStatusChange: PropTypes.func,
  onUnlock: PropTypes.func,
  onReInviteUser: PropTypes.func.isRequired,
};

export const ManageUsersRowComponent = ManageUsersRow;

export default connect()(ManageUsersRowComponent);
